// Menu Item Text
export enum MenuItemText {
  ViewClosedReferral = 'Click here to view the closed referral',
  ContinueNewReferralScreen = 'Continue to the new referral screen',
  ViewStudentProfile = 'View student profile',
  CreateNewStudent = 'Create new student',
  CreateRequestForReevaluation = 'Create Request for Reevaluation',
  CreateRequestForAdditionalReevaluation = 'Create Request for Additional Reevaluation',
  CreateRequestForMandatedThreeYearReevaluation = 'Create Request for Mandated Three-Year Reevaluation',
  CreateMandatedThreeYearReevaluation = 'Create Mandated Three-Year Reevaluation',
  WaiveMandatedThreeYearReevaluation = 'Waive Mandated Three-Year Reevaluation',
  CreateLinkStudent = 'Create/Link Student',
  ContinueWithCSP = 'Continue with CSP',
}
